const questions = [
  {
    question:
      "As I was returning from Belfast, I saw a 6 feet tall man with bright blue eyes and golden brown hair running down the street. He had stolen a  purse and I saw a swastika on his shirt. As I was trying to catch him, he pushed me and screamed something in his native language. The camera have recorded what he said. Can you help me identify which language it was?.",
    optionA: "German",
    optionB: "Japanies",
    optionC: "Hindi",
    optionD: "Polish",
    answer: "Hindi",
  },

  {
    question:
      "As I was returning from college, I went found a dark street down the lane, a man with his small shop was cooking pasta, which seemed delicious, I asked him what's the price, he replied 'mamma mia', before I resume the conversation, can u help me find out his native language?",
    optionA: "Spanish",
    optionB: "German",
    optionC: "Italian",
    optionD: "Gujrati",
    answer: "German",
  },

  {
    question:
      "Mycroft finally had caught the culprit he's been trying to reach after 5 years. She is an African American woman in her mid 30's. Yesterday, she broke the jail's cell and ran away. As a security guard was trying to grab her she screamed something which has been recorded in the cctv. What language was she speaking in?",
    optionA: "Albanian",
    optionB: "Arabic",
    optionC: "Polish",
    optionD: "Indonasian",
    answer: "Polish",
  },

  {
    question:
      "As i was returning from college , i found a dark street past the raod , a man with his small shop was cooking pasta , which seemed delicious , i asked him what's the price , he replied 'mamma mia' , before i  could resume the conversation , can u help me find out his native language ?",
    optionA: "Russina",
    optionB: "Spanish",
    optionC: "Hindi",
    optionD: "Albanian",
    answer: "Spanish",
  },

  {
    question:
      "It's always tricky to identify the culprit when there aren't any proofs. Surprisingly, the only proof we had in one particular case was that he was Iraqi. Can you tell me what language this possible culprit is speaking in, Watson, so that we catch the real criminal?",
    optionA: "Italian",
    optionB: "French",
    optionC: "Spanish",
    optionD: "Katana",
    answer: "Italian",
  },

  {
    question:
      "Watson, I'm heartbroken today as the criminal that I've chased for 5 years killed himself. I was about to throw the gun out if his hands but he shot himself just in time. The only last message I could find in his phone is in a different language. What language is he speaking in?",
    optionA: "Hindi",
    optionB: "Irish",
    optionC: "Arabic",
    optionD: "Russian",
    answer: "Russian",
  },

  {
    question:
      "Yesterday i encountered a man lying half dead on the street , screaming in pain , i asked him where he is from , about his details , but i could not understand what he was saying , later on i contacted his family through his phone , which had a wallpaper depicting him and beneath him was 'iifel tower' , can you help me find out his native language?",
    optionA: "French",
    optionB: "Hindi",
    optionC: "Armenian",
    optionD: "Samoan",
    answer: "French",
  },

  {
    question:
      "As I was returning from Belfast, I saw a 6 feet tall man with bright blue eyes and golden brown hair running down the street. He had stolen a  purse and I saw a swastika on his shirt. As I was trying to catch him, he pushed me and screamed something in his native language. The camera have recorded what he said. Can you help me identify which language it was?.",
    optionA: "Sinhala",
    optionB: "Japanese",
    optionC: "Sindhi",
    optionD: "Slovak",
    answer: "Japanese",
  },

  {
    question:
      "As i was chasing the thief, I saw a girl in kimono, with red eyes signalling the theif to run faster. Soon she removed the kimono on street, she was wearing stockings and ninja vest under the kimono.",
    optionA: "Chinease",
    optionB: "Hindi",
    optionC: "Russian",
    optionD: "Polish",
    answer: "Chinease",
  },

  {
    question:
      "Watson, I attended the cremation of a 4 year old girl today. She was brutally murdered for money. I caught the victim and i tried to inform the family about it but i dont seem to identify their native language. Can you help me to identify what language they were speaking in?",
    optionA: "Japanese",
    optionB: "Icelandian",
    optionC: "Albanian",
    optionD: "Irish",
    answer: "Albanian",
  },
];
export default questions;
